import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import locale from '@fullcalendar/core/locales/ro';
import {Romanian} from "flatpickr/dist/l10n/ro"; //italian language and config
const flatpickr = require("flatpickr");
const Russian = require("flatpickr/dist/l10n/ru.js").default.ru;

document.addEventListener('DOMContentLoaded', function () {

    const calendarEl = document.getElementById("calendar");


    if (calendarEl !== null) {
        window.calendar = new Calendar(calendarEl, {
            locale: locale,
            plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
            initialView: 'listWeek',
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,listWeek'
            },
            events: {
                url: "/api/appointment?api_token=" + window.sessionStorage.getItem('api_token'),
            },

            eventClick: function (info) {
                let prop = info.event.extendedProps.customParams;
                sweetAlertFire(info, prop);
            }
            // go ahead with other parameters
        });
        calendar.render();
    }

    const button = document.getElementById("createAppoint");

    if(button !== null){
        button.addEventListener("click", function() {
            window.fetch("/api/appointment/create?api_token=" + window.sessionStorage.getItem('api_token'))

                .then((res) => res.text())
                .then((body) => {
                    $("#modalContent").html(body);
                    $("#appointCreate").modal('show');
                    window.livewire.rescan();
                    initDatePicker(document.getElementById("date1"), [])
                });
        });
    }

});

window.addEventListener('appoint-updated', event => {
    $('#appointEdit').modal('hide');
    $('#appointCreate').modal('hide');
    if (window.calendar){
        window.calendar.refetchEvents();
    } //else location.reload();
});

function sweetAlertFire(info, prop) {
    if (prop.status === "Deservit"){
        Swal.fire({
            title: '<strong>Nume: ' + info.event.title + '</strong>',
            icon: 'info',
            html:"<p class='text-left'><strong>Data/ora: </strong>" + info.event.start.toLocaleString('ro-Ro') + "</p>" +
                "<p class='text-left'><strong>Telefon:</strong> " + prop.phone + "</p>" +
                "<p class='text-left'><strong>Email:</strong> " + prop.email + "</p>" +
                "<p class='text-left'><strong>Oficiul comercial:</strong> " + prop.officeName + "</p>" +
                "<div class='text-left'><div class='font-weight-bold'>Scopul vizitei:</div> " + prop.type + "</div><br>"+
                "<p class='text-left'><strong>NLC: </strong>" + prop.nlc + "</p>"+
                "<p class='text-left'><strong>Status: </strong>" + prop.status + "</p>"+
                "<div class='text-left'><div class='font-weight-bold'>Descriere:</div> " + prop.description + "</div><br>",
            showCloseButton: true,
        })
    } else {
        window.Swal.fire({
            title: '<strong>Nume: ' + info.event.title + '</strong>',
            icon: 'info',
            html: "<p class='text-left'><strong>Data/ora: </strong>" + info.event.start.toLocaleString('ro-Ro') + "</p>" +
                "<p class='text-left'><strong>Telefon:</strong> " + prop.phone + "</p>" +
                "<p class='text-left'><strong>Email:</strong> " + prop.email + "</p>" +
                "<p class='text-left'><strong>Oficiul comercial:</strong> " + prop.officeName + "</p>" +
                "<div class='text-left'><div class='font-weight-bold'>Scopul vizitei:</div> " + prop.type + "</div><br>"+
                "<p class='text-left'><strong>NLC: </strong>" + prop.nlc + "</p>"+
                "<p class='text-left'><strong>Status: </strong>" + prop.status + "</p>"+
                "<div class='text-left'><div class='font-weight-bold'>Descriere:</div> " + prop.description + "</div><br>"+
                '<button id="served" data-id="'+prop.id+'" tabindex="0" class="btn btn-primary align-items-start"><i class="far fa-check-circle"></i>  &nbsp;' + '  Deservit' + '</button>',
            showCloseButton: true,
            showCancelButton: true,
            showDenyButton: true,
            focusConfirm: false,
            confirmButtonText:
                '<i class="far fa-edit"></i> Editează',
            confirmButtonAriaLabel: 'Editează',
            cancelButtonText:
                '<i class="far fa-times-circle"></i> Închide',
            cancelButtonAriaLabel: 'Închide',
            denyButtonText: `<i class="far fa-calendar-times"></i>  Anulează`
        }).then((result) => {
            if (result.isConfirmed) {
                window.fetch("/api/appointment/" + prop.id + "/edit?api_token=" + window.sessionStorage.getItem('api_token'))
                    .then((res) =>{
                        return res.json()})
                    .then((body) => {
                        $("#modalContent").html(body.view);
                        $("#appointEdit").modal('show');
                        window.livewire.rescan();
                        const enabled = body.dates.map(item => new Date(item));
                        initDatePicker(document.getElementById("date1"), enabled)
                    });
            } else if (result.isDenied){
                window.Swal.fire({
                    title: 'Adaugă un comentariu',
                    input: 'textarea',
                    inputAttributes: {
                        autocapitalize: 'off',
                        required: true
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Salveză',
                    showLoaderOnConfirm: true,
                    preConfirm: (comment) => {
                        return fetch("/api/appointment/"+ prop.id +"/cancel?api_token=" + window.sessionStorage.getItem('api_token') + "&comment=" + comment)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response
                            })
                            .catch(error => {
                                window.Swal.showValidationMessage(
                                    `Request failed: ${error}`
                                )
                            })
                    },
                    allowOutsideClick: () => !window.Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.Swal.fire({
                            title: `Programarea a fost anulată !`,
                        })
                        window.calendar.refetchEvents();
                    }
                })
            }
        });
    }
}

window.addEventListener('view-appoint', (event) => {
    let info = {
        event: {
            title: event.detail.appoint.name
        }
    }
    let prop = event.detail.appoint;
    sweetAlertFire(info, prop);
})

window.addEventListener('update-vue', (event) => {
    const enabled = JSON.parse(event.detail.dates).map(item => new Date(item));
    initDatePicker(document.getElementById("date1"), enabled)
})



document.addEventListener("DOMContentLoaded", function(event) {

    const dateEl = document.getElementById("date1");

    if (dateEl){
        initDatePicker(dateEl, []);
    }

    const office = document.getElementById("office");
    if (office){
        office.addEventListener("change", (e) => {
            let url = "/api/appointment?api_token=" + window.sessionStorage.getItem('api_token') + "&office_id=" + e.target.value ;

            window.calendar.removeAllEvents();
            window.calendar.addEventSource(url)
        });
    }

});

function initDatePicker(dateEl, enabled){
    dateEl.flatpickr({
        dateFormat: "d.m.Y",
        altInput: true,
        altFormat: "j F, Y",
        altInputClass : "invisible",
        inline: true,
        defaultDate: null,
        minDate: new Date().fp_incr(1),
        maxDate: new Date().fp_incr(30),
        "locale": Romanian,
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);

            }
        ],
        'enable': enabled
    });

}


$(document).on("click", "#served", function (event) {

    let id = $(this).attr('data-id');

    Swal.fire({
        title: 'Adaugă un comentariu',
        input: 'textarea',
        inputAttributes: {
            autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'OK',
        showLoaderOnConfirm: true,
        preConfirm: (comment) => {
            return window.fetch("/api/appointment/" + id + "/served?api_token=" + window.sessionStorage.getItem('api_token') + "&comment=" + comment)
                .then((res) => {
                    if (res.status === 200) {

                        let timerInterval
                        window.Swal.fire({
                            title: 'Clientul a fost deservit',
                            html: '',
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: () => {
                                window.Swal.showLoading()
                                const b = window.Swal.getHtmlContainer().querySelector('b')
                                timerInterval = setInterval(() => {
                                    b.textContent = Swal.getTimerLeft()
                                }, 100)
                            },
                            willClose: () => {
                                clearInterval(timerInterval)
                            }
                        }).then((result) => {
                            /* Read more about handling dismissals below */
                            if (result.dismiss === window.Swal.DismissReason.timer) {
                            }
                        })
                        window.calendar.refetchEvents();
                    }
                })
        }
    });
});

$(document).on('click', "#report-client", async (e) => {
    e.preventDefault();
    let id = $(e.target).attr("data-id");
    await window.fetch("/api/appointment/" + id + "/edit?api_token=" + window.sessionStorage.getItem('api_token'))
        .then((res) =>{
            return res.json()})
        .then((body) => {
            $("#modalContent").html(body.view);
            $("#appointEdit").modal('show');
            window.livewire.rescan();
            const enabled = body.dates.map(item => new Date(item));
            initDatePicker(document.getElementById("date1"), enabled)
        });
});

